'use client';
import r from 'deepmerge';

function mergeArrays(r, e, t) {
    let { cloneUnlessOtherwiseSpecified: a, isMergeableObject: g } = t, m = [
        ...r
    ];
    return e.forEach((e, n)=>{
        let o = r[n];
        g(e) ? m[n] = mergeTwo(o, e) : m[n] = a(e, t);
    }), m;
}
function mergeTwo(e, t) {
    return r(e, t, {
        arrayMerge: mergeArrays
    });
}
function merge(e) {
    return r.all(e, {
        arrayMerge: mergeArrays
    });
}

export { merge };
